// Load Active Admin's styles into Webpacker,
// see `active_admin.scss` for customization.
import 'tom-select/dist/css/tom-select.default.css'
import "~/stylesheets/active_admin.scss";
import '~/jquery'
import 'jquery-ui'
import 'jquery-ui/ui/widgets/mouse'
import "@activeadmin/activeadmin";
import { DeclarationOrder } from '~/active_admin/declaration_orders';
import { Order } from '~/active_admin/orders';
import { UserSelect } from '~/active_admin/user_select';
import { SummaryViewer } from '~/active_admin/summary_viewer';

DeclarationOrder();
Order();
UserSelect();
SummaryViewer();
